// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EnhQ","textarea":"styles_textarea__15Lu7"};